module.exports = __webpack_public_path__ + "img/4创建项目.a240adec.gif";